$(document).ready(function () {
    $('.tv_channels_btn_wrapper button').on('click', function (e) {
        e.preventDefault()

        $('.tv_channels_btn_wrapper button').removeClass('active_btn')
        $(this).addClass('active_btn')

        let category = $(this).data('category')
        let tariff = $(this).data('tariff')
        let tvChannels = '#tv_channels_container .tv_card'

        $(tvChannels).show()

        if (tariff === '' && category === '') {

        } else if (category !== '') {
            $(tvChannels).hide()
            $(tvChannels + '[data-category="'+ category +'"]').show()
        } else if (tariff !== '') {
            $(tvChannels).hide()
            $(tvChannels + '['+ tariff +']').show()
        }
    })

    if ($('.tv_channels_btn_wrapper button').hasClass('active-choice')) {
        $('.tv_channels_btn_wrapper button.active-choice').click()
    }
})
